import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/modules/user";
import Point from "./modules/point";
import mapLevel from "./modules/mapLevel";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    Point,
    mapLevel,
  },
});
